// @flow strict

import * as React from 'react';

type PropTypes = {|
  embedSrc: string,
|};

export default (props: PropTypes) => {
  const { embedSrc = '' } = props;

  React.useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('data-ceros-origin-domains', 'www.ansarada.com');
    script.src = 'https://view.ceros.com/scroll-proxy.min.js';

    if (document.body) {
      document.body.appendChild(script);
    }

    return () => {
      script.remove();
    };
  }, []);

  const css2obj = css => {
    const r = /(?<=^|;)\s*([^:]+)\s*:\s*([^;]+)\s*/g;
    const o = {};
    // eslint-disable-next-line no-return-assign
    String(css).replace(r, (_m, p, v) => (o[p] = v));
    return o;
  };

  if (!embedSrc) return null;

  const temp = embedSrc.split('/');
  const title = temp[temp.length - 1];

  const divStyle =
    "position: relative;width: auto;padding: 0 0 56.25%;height: 0;top: 0;left: 0;bottom: 0;right: 0;margin: 0;border: 0 none'";
  const divDataAspectRatio = '1.77777778';
  const iframeStyle =
    'position: absolute;top: 0;left: 0;bottom: 0;right: 0;margin: 0;padding: 0;border: 0 none;height: 1px;width: 1px;min-height: 100%;min-width: 100%';

  return (
    <div style={css2obj(divStyle)} data-aspectRatio={divDataAspectRatio}>
      <iframe
        allowFullScreen
        src={embedSrc}
        style={css2obj(iframeStyle)}
        frameBorder="0"
        title={title}
        scrolling="no"
      />
    </div>
  );
};
